import {
    // FILE_UPLOAD,
    CREATE_SERVICE_USER_ACTIVITIES,
    RETRIEVE_SERVICE_USER_ACTIVITIES,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_SERVICE_USER_ACTIVITIES,
    UPDATE_SERVICE_USER_ACTIVITIES,
    DELETE_SERVICE_USER_ACTIVITIES,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import ServiceUserActivities from "../service/ServiceUserActivities";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ServiceUserActivities.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ServiceUserActivities.create(data);
        dispatch({
            type: CREATE_SERVICE_USER_ACTIVITIES,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ServiceUserActivities.fetchList(data);
        dispatch({
            type: RETRIEVE_SERVICE_USER_ACTIVITIES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ServiceUserActivities.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SERVICE_USER_ACTIVITIES,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ServiceUserActivities.update(data);
        dispatch({
            type: UPDATE_SERVICE_USER_ACTIVITIES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ServiceUserActivities.changeStatus(data);
//         dispatch({
//             type: UPDATE_SERVICE_USER_ACTIVITIES,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ServiceUserActivities.trash(data);
        dispatch({
            type: DELETE_SERVICE_USER_ACTIVITIES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};